import React, { Fragment } from "react";
import uploadIcon from "../../assets/images/new-dashboard/uploadIcon.png";
import downloadIcon from "../../assets/images/new-dashboard/downloadIcon.png";
import recipeIcon from "../../assets/images/new-dashboard/recipeIcon.png";
import menuIcon from "../../assets/images/new-dashboard/menuIcon.png";
import youTubeIcon from "../../assets/images/new-dashboard/youTubeIcon.png";
import videoCalendarIcon from "../../assets/images/new-dashboard/video_calendarIcon.png";
import starsIcon from "../../assets/images/new-dashboard/starsIcon.png";
import pinIcon from "../../assets/images/new-dashboard/pinIcon.svg";
import menuItemIcon from "../../assets/images/new-dashboard/menuItemIcon.svg";
import dollorIcon from "../../assets/images/new-dashboard/dollorIcon.svg";
import fileIcon from "../../assets/images/new-dashboard/fileIcon.svg";
import thumbsUp from "../../assets/images/new-dashboard/Thumb_Like.png";
import thumbsDown from "../../assets/images/new-dashboard/Thumb_Dislike.png";
import WookaiAI from "../../assets/images/new-dashboard/WookaiAI.png";
import WookaiAIGif from "../../assets/images/new-dashboard/gif-image.gif";
import CloseBlack from "../../assets/images/close.png";
import attachIcon from "../../assets/images/new-dashboard/attachIcon.png";
import avatar from "../../assets/images/users/avatar-1.jpg";
import newGraph from "../../assets/images/new-graph.png";
import { withRouter, Link } from "react-router-dom";
import { httpGet, httpPost, gptPostData, gptGetData, gptDeleteData, gptPatchData } from "../../utils/http";
import "./style.css";
import { DASHBOARD_ENDPOINT, PRODUCTS_ENDPOINT, VENDORS_ENDPOINT, GPT_BASE_URL, BUCKET_URL, ASSETS_PATH } from "../../config/endPoints";
import { Line } from "react-chartjs-2";
import Select from "react-select";
import { errorToaster } from "../../components/Common/Toaster";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  FormGroup,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardText,
  Dropdown,
  dropdownOpen,
  toggle,
  direction,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown

} from "reactstrap";
import { success } from "toastr";

const customStyles2 = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      //   color: data.parent_id == null ? "#f97c00" : '#2491eb',
      //   marginLeft: data.parent_id != null ? '10px' : '',
      //   backgroundColor: isFocused ? "#F1F1F1" : null
    };
  },
  menuPortal: (base) => ({ ...base, zIndex: 5 }),
};

// 🧠 Example supplier data with mixed continuity (gaps + no gaps)
const supplierData = {
  PFG: [
    { date: "2025-10-25", price: 101 },
    { date: "2025-10-26", price: 103 },
    { date: "2025-10-28", price: 107 }, // gap on 27
    { date: "2025-10-29", price: 108 },
    { date: "2025-10-31", price: 110 }, // gap on 30
    { date: "2025-11-02", price: 112 },
    { date: "2025-11-05", price: 113 },
    { date: "2025-11-07", price: 115 },
    { date: "2025-11-09", price: 118 },
  ],
  Sysco: [
    { date: "2025-10-25", price: 97 },
    { date: "2025-10-26", price: 98 },
    { date: "2025-10-27", price: 99 },
    { date: "2025-10-28", price: 98 },
    { date: "2025-10-29", price: 99 },
    { date: "2025-10-30", price: 100 },
    { date: "2025-10-31", price: 102 },
    { date: "2025-11-01", price: 103 },
    { date: "2025-11-02", price: 104 },
    { date: "2025-11-03", price: 106 },
    { date: "2025-11-04", price: 107 },
    { date: "2025-11-05", price: 107 },
    { date: "2025-11-06", price: 108 },
  ],
  Gordon: [
    { date: "2025-10-25", price: 100 },
    { date: "2025-10-28", price: 101 },
    { date: "2025-11-01", price: 103 },
    { date: "2025-11-03", price: 104 },
    { date: "2025-11-05", price: 106 },
    { date: "2025-11-07", price: 107 },
  ],
  Chenai: [
    { date: "2025-10-27", price: 95 },
    { date: "2025-10-29", price: 96 },
    { date: "2025-10-30", price: 96 },
    { date: "2025-11-01", price: 98 },
    { date: "2025-11-04", price: 100 },
    { date: "2025-11-08", price: 101 },
    { date: "2025-11-09", price: 101 },
  ],
  "MR. GREENJEANS": [
    { date: "2025-10-25", price: 93 },
    { date: "2025-10-28", price: 95 },
    { date: "2025-10-30", price: 96 },
    { date: "2025-11-01", price: 98 },
    { date: "2025-11-02", price: 97 },
    { date: "2025-11-04", price: 99 },
    { date: "2025-11-06", price: 101 },
    { date: "2025-11-09", price: 103 },
  ],
};

// 🧩 Step 1: Collect all unique dates from all suppliers
const allDates = Array.from(
  new Set(Object.values(supplierData).flatMap((s) => s.map((d) => d.date)))
).sort();

console.log("allDates", allDates);

// 🧩 Step 2: Align supplier data by date (fill missing with null)
function mapPrices(data, dates) {
  return dates.map((date) => {
    const found = data.find((d) => d.date === date);
    return found ? found.price : null;
  });
}

// 🧩 Step 3: Chart options
const options = {
  responsive: true,
  plugins: {
    legend: { position: "top" },
    title: {
      display: true,
      text: "Supplier Price History (10–30 Days, With Gaps)",
    },
    tooltip: {
      callbacks: {
        title: (context) => `Date: ${context[0].label}`,
        label: (context) =>
          `${context.dataset.label}: $${context.raw ?? "N/A"}`,
      },
    },
  },
  scales: {
    x: {
      title: { display: true, text: "Date" },
    },
    y: {
      title: { display: true, text: "Price ($)" },
      beginAtZero: false,
    },
  },
};

// 🧩 Step 4: Create datasets dynamically
const supplierColors = [
  "rgb(255, 99, 132)", // pink-red
  "rgb(53, 162, 235)", // blue
  "rgba(41, 221, 131, 1)", // green
  "rgba(200, 158, 195, 1)", // soft purple
  "rgba(149, 62, 168, 1)", // deep violet
  "rgba(255, 159, 64, 1)", // orange
  "rgba(255, 205, 86, 1)", // yellow
  "rgba(75, 192, 192, 1)", // teal
  "rgba(153, 102, 255, 1)", // light purple
  "rgba(201, 203, 207, 1)", // grey
  "rgba(255, 87, 34, 1)", // deep orange
  "rgba(0, 188, 212, 1)", // cyan
  "rgba(63, 81, 181, 1)", // indigo
  "rgba(156, 39, 176, 1)", // violet
  "rgba(139, 195, 74, 1)", // lime green
  "rgba(205, 220, 57, 1)", // light lime
  "rgba(121, 85, 72, 1)", // brown
  "rgba(233, 30, 99, 1)", // pink
  "rgba(0, 150, 136, 1)", // dark teal
  "rgba(158, 158, 158, 1)", // neutral grey
];

// const data = {
//   labels: allDates,
//   datasets: Object.entries(supplierData).map(([supplier, values], i) => ({
//     label: supplier,
//     data: mapPrices(values),
//     borderColor: supplierColors[i % supplierColors.length],
//     fill: false,
//     tension: 0.4,
//     spanGaps: false, // show visible breaks for missing days
//     pointRadius: 4,
//     pointHoverRadius: 6,
//   })),
// };

class Dashboard extends React.Component {
  state = {
    menuItemOverTarget: 0,
    contractsExpiring: 0,
    rebatesExpiring: 0,
    keySupplies: [],
    selectedBusinessLocationObject: JSON.parse(
      localStorage.getItem("businessLocationObject")
    ),
    productList: [],
    vendorList: [],
    selectedProduct: null,
    days: 60,
    graphData: {},
    selectedVendor: '',
    top5Highest: [],
    top5Lowest: [],
    highOrLow: 'low',
    gpt: [],
    chatText: '',
    gptLoading: false,
    userObject: JSON.parse(localStorage.getItem('wookaiUserObject')),
    chatId: '',
    conversationHistory: [],
    page: 1,
    totalConversations: 0,
    masterBusinessLocationObject: JSON.parse(
      localStorage.getItem("firstBusinessLocationObject")
    ),
    isGptKey: false,
    isModal: false,
    activeTab: 'master',
    favourites: []
  };

  chatScrollRef = React.createRef();
  historyRef = React.createRef();


  componentDidMount() {

    if(this.state.selectedBusinessLocationObject){
      this.checkGPTKey();
      this.getSupplierList();
      this.getNotableItems();
      this.getKeySupplies();
      this.getProductsList();
      this.getGptHistory();
      this.getFavourites();


      this.scrollToBottom();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.gpt !== this.state.gpt) {
      this.scrollToBottom();
    }
  }

  checkGPTKey = () => {
    const {masterBusinessLocationObject, selectedBusinessLocationObject} = this.state;

    if(selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.is_slave == 0 && selectedBusinessLocationObject.gpt_key){
      this.setState({
        isGptKey: true
      })
    }else if(masterBusinessLocationObject != undefined && masterBusinessLocationObject.gpt_key){
      this.setState({
        isGptKey: true
      })
    }
  }

  getProductsList = async () => {
    let res = await httpGet(`${PRODUCTS_ENDPOINT}/get/list`);
    res = res.data;
    console.log("res**", res);
    let arr = [];
    for (let i = 0; i < res.length; i++) {
      arr = [...arr, { value: res[i].id, label: res[i].product_name }];
    }

    this.setState({
      productList: arr,
    });
  };

  getSupplierList = async () => {
      let res = await httpGet(`${VENDORS_ENDPOINT}/get/list`);
      res = res.data;
      console.log('venodrs***', res);
      this.setState({
          vendorList: res,
      });
    };

  getNotableItems = async () => {
    let res1 = await httpGet(`${DASHBOARD_ENDPOINT}/menuItemOverTarget`);

    this.setState({
      menuItemOverTarget: res1.data.count,
      top5Highest: res1.data.top5Highest,
      top5Lowest: res1.data.top5Lowest
    });

    let res2 = await httpGet(`${DASHBOARD_ENDPOINT}/contractsExpiring`);

    this.setState({
      contractsExpiring: res2.data.contractsCount,
      rebatesExpiring: res2.data.rebatesCount,
    });
  };

  getKeySupplies = async () => {
    let res = await httpGet(`${DASHBOARD_ENDPOINT}/keySupplies`);
    this.setState({
      keySupplies: res.data,
    });
  };

  productChange = async (selectedOption) => {
    const { days, selectedVendor } = this.state;
    this.setState({
      selectedProduct: selectedOption,
    });

    let res = await httpGet(
      `${DASHBOARD_ENDPOINT}/priceChangeHistory/${selectedOption.value}?days=${days}&vendorId=${selectedVendor}`
    );
    res = res.data;

    let newData = {
      labels: res.dates,
      datasets: Object.entries(res.prices).map(([supplier, values], i) => ({
        label: supplier,
        data: mapPrices(values, res.dates),
        borderColor: supplierColors[i % supplierColors.length],
        fill: false,
        tension: 0.4,
        spanGaps: false, // show visible breaks for missing days
        pointRadius: 4,
        pointHoverRadius: 6,
      })),
    };

    console.log("new Data", newData);

    this.setState({
      graphData: newData,
    });
  };

  daysChange = (days) => {
    const { selectedProduct } = this.state;
    this.setState({ days });

    setTimeout(() => {
      if (selectedProduct) {
        this.productChange(selectedProduct);
      }
    }, 500);
  };

  supplierChange = (e) => {
    const { selectedProduct } = this.state;

    this.setState({
        selectedVendor: e.target.value
    })

     setTimeout(() => {
      if (selectedProduct) {
        this.productChange(selectedProduct);
      }
    }, 500);
  }

  profitabilityChange = (e) => {
    this.setState({
      highOrLow: e.target.value
    })
  }

  chatInputHandler = (e) => {
    this.setState({
      chatText: e.target.value
    })
  }


formatAIMessage(text) {
  if (!text) return "";

  // remove fenced code blocks but only if they contain markdown table
  let cleaned = text.replace(/```markdown|```/g, "");

  // ✔ Detect if there is at least one table row pattern (| col | col |)
  const hasTable = /\|.*\|/.test(cleaned);

  // If table exists, convert it to HTML table
  if (hasTable) {
    cleaned = cleaned.replace(
      /((?:\|.+\|[\r\n]+)+)/g,
      (table) => {
        const rows = table.trim().split("\n");

        return `
          <table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width:100%; font-size:14px;">
            ${rows
              .map((row, i) => {
                // Skip markdown separator like |----|---|
                if (/^\|\s*-+/.test(row)) return "";

                const cols = row.split("|").map((col) => col.trim()).filter(Boolean);

                // header row (first row)
                if (i === 0) {
                  return `<tr>${cols.map((c) => `<th style="background:#f2f2f2; text-align:left;">${c}</th>`).join("")}</tr>`;
                }

                // normal table rows
                return `<tr>${cols.map((c) => `<td>${c}</td>`).join("")}</tr>`;
              })
              .join("")}
          </table>
        `;
      }
    );
  }

  // Normal formatting (works for all other responses)
  return cleaned
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>") // bold
    .replace(/\\n/g, "<br/>")              // literal \n
    .replace(/\n/g, "<br/>");              // real new lines
}


  sendMessage = async () => {
    const { gpt, chatText, chatId, isGptKey } = this.state; 
    
    if(!chatText) return false;

    if(!isGptKey){
      errorToaster('Please add the GPT key in business location', 'Error');
      return false;
    }

    let chatIdNew = '';
    if(!chatId){
      chatIdNew = await this.createChat(chatText)
    }

    this.setState({
      gptLoading: true
    })

    let cloned = [...gpt];

    cloned = [...cloned, {
      sender_type: 'user',
      message: chatText,
      data: null
    }];

    this.setState({
      gpt: cloned,
      chatText: '',
    })

    let res = await gptPostData(`${GPT_BASE_URL}/prompt/${chatId ? chatId : chatIdNew}`, {
      q: chatText
    });

    console.log('res**', res);

    if(res.status != 200){
      errorToaster(res.data.detail, 'Error');
      return false;
    }

    cloned = [...cloned, { 
      sender_type: 'bot',
      message: res.data.data.friendly_response,
      data: null,
      flag: null,
      uuid: res.data.data.bot_message_uuid
    }]

    this.setState({
      gpt: cloned,
      gptLoading: false
    })
    
  }



  scrollToBottom = () => {
    if (this.chatScrollRef.current) {
      const el = this.chatScrollRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth" // This makes the scroll smooth
      });
    }
  };

  createChat = async (text) => {
    const { conversationHistory, isGptKey } = this.state;

    if(!isGptKey){
      errorToaster('Please add the GPT key in business location', 'Error');
      return false;
    }

    this.setState({
      chatId: ''
    });

    let res = {};
    if(text){
      res = await gptPostData(`${GPT_BASE_URL}/create-conversation`, {
        title: text
      });

      let cloned = [...conversationHistory];

      this.setState({
        chatId: res.data.data.conversation_uuid,
        conversationHistory: [res.data.data, ...cloned]
      })
    }

    this.setState({
      gpt: []
    })

    // this.getGptHistory();

    if(text){
      return res.data.data.conversation_uuid;
    }

    return '';
  }

  getFavourites = async () => {
    const  { activeTab, selectedBusinessLocationObject } = this.state;

    let url = '';

    if(selectedBusinessLocationObject.is_slave == 0){
      if(activeTab == 'master'){
        url += `is_master=true`
      }else if(activeTab == 'slave'){
        url += `is_slave=true`;
      }

      let res = await gptGetData(`${GPT_BASE_URL}/conversations/history?is_favourite=true&${url}`);

      this.setState({
        favourites: res.data.data.conversations
      })
    }else{
       if(activeTab == 'master'){
       this.getMasterFavouritesForSlave();
      }else if(activeTab == 'slave'){
        url += `is_slave=true`;

        let res = await gptGetData(`${GPT_BASE_URL}/conversations/history?is_favourite=true&${url}`);

        this.setState({
          favourites: res.data.data.conversations
        })
      }
    }



  }

  getMasterFavouritesForSlave = async () => {
    const  { activeTab, selectedBusinessLocationObject } = this.state;

    let master_id = selectedBusinessLocationObject.master_id;
  
    let  url = `is_slave=true`;
    console.log('master_id**', master_id);
    let res = await gptGetData(`${GPT_BASE_URL}/conversations/history?is_favourite=true&${url}`, master_id);

    this.setState({
      favourites: res.data.data.conversations
    })
  }

  getGptHistory = async (increase = false) => {
    const { page, conversationHistory } = this.state;

    let updatedPage = page;
    if(increase){
      updatedPage++;
    }

    let res = await gptGetData(`${GPT_BASE_URL}/conversations/history?page=${updatedPage}&limit=10`);

    let clone = [...conversationHistory];

    this.setState({
      conversationHistory: [...clone, ...res.data.data.conversations],
      page: updatedPage,
      totalConversations: res.data.data.total_conversations
    },
    () => {
      // 🔥 scroll to bottom AFTER render
      if (this.historyRef.current) {
        this.historyRef.current.scrollTop =
          this.historyRef.current.scrollHeight;
      }
    })
  }

  deleteConversation = async (id) => {
    const { chatId, conversationHistory } = this.state;
    let res = await gptDeleteData(`${GPT_BASE_URL}/delete/conversation/${id}`);

    console.log('id', id);
    console.log('chatId', chatId);
    if(id == chatId){
      this.setState({
        chatId: '',
        gpt: ''
      })
    }

     this.setState({
        conversationHistory: conversationHistory.filter(c => c.conversation_uuid !== id),
      })

    // this.getGptHistory();
  }

  getMessageHistory = async (id) => {
    let res = await gptGetData(`${GPT_BASE_URL}/messages/${id}`);

    this.setState({
      gpt: res.data.data.messages,
      chatId: id
    })
  }

  reactOnMsg = async (id, current, proposed) => {
    const { chatId, gpt } = this.state;

    let flag = proposed;
    if(proposed == current){
      flag = '';
    }

    let res = await gptPatchData(`${GPT_BASE_URL}/conversation/${chatId}/message/${id}`, {flag});

    let cloned = [...gpt];

    let index = cloned.findIndex((x) => x.uuid == id);
    console.log('index', index);
    if(index > -1){
      cloned[index].flag = res.data.data.flag;
      this.setState({
        gpt: cloned
      })
    }
    
  }

  /**
   * close Modal
   */
  closeModal = () => {
    this.setState((prevState) => ({
      isModal: !prevState.isModal,
    }));
  };

  /**
   * 
   * @returns 
   */
  openModal = () => {
    this.getFavourites();
    this.setState((prevState) => ({
      isModal: !prevState.isModal,
    }));
  }

  /**
   * 
   * @returns 
   */
  changeTab = (type) => {
    this.setState({
      activeTab: type
    })

    setTimeout(() => {
      this.getFavourites();
    }, 500)
  }
  
  /**
   * 
   * @returns 
   */
  markFavourite = async (type) => {
    const { chatId, selectedBusinessLocationObject } = this.state;

    if(!chatId){
      errorToaster('Please choose the conversation.', 'Error');
      return false;
    }

    if(selectedBusinessLocationObject.is_slave == 0){
      let ob = {
        is_favourite: true
      };

      if(type == 'master'){
        ob.is_master = true;
        ob.is_slave = false;
        ob.is_local = false;
      }else if(type == 'slave'){
        ob.is_master = true;
        ob.is_slave = true;
        ob.is_local = false;
      }

      await gptPostData(`${GPT_BASE_URL}/favourite/conversation/${chatId}`, {...ob});
    }else{
      await gptPostData(`${GPT_BASE_URL}/favourite/conversation/${chatId}`, {is_favourite: true, is_slave: true, is_local: true});
    }

    success('Favorite marked successfully', 'Success');
  }

  showFavouriteDetail = (id) => {
    this.closeModal();
    this.getMessageHistory(id);
  }

  unMarkFavourite = async (chatId) => {
    await gptPostData(`${GPT_BASE_URL}/favourite/conversation/${chatId}`, {is_favourite: false});
    this.getFavourites();


    success('Favorite removed.', 'Success');
  }


  render() {
    const {
      menuItemOverTarget,
      contractsExpiring,
      rebatesExpiring,
      selectedBusinessLocationObject,
      keySupplies,
      productList,
      selectedProduct,
      days,
      graphData,
      vendorList,
      top5Highest,
      top5Lowest,
      highOrLow,
      gpt,
      chatText,
      gptLoading,
      userObject,
      conversationHistory,
      totalConversations,
      isModal,
      activeTab,
      favourites
    } = this.state;
    return (
      <Fragment>
        <Modal size="xl" isOpen={isModal} toggle={() => this.closeModal}>
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              Favorites
            </h5>
            <button
              type="button"
              onClick={() => this.closeModal()}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div>
              <Nav tabs>
                <NavItem onClick={() => this.changeTab('master')}>
                  <NavLink
                    className={activeTab == 'master' ? 'active' : ''}
                  >
                    Enterprise
                  </NavLink>
                </NavItem>
                <NavItem onClick={() => this.changeTab('slave')}>
                  <NavLink
                    className={activeTab == 'slave' ? 'active' : ''}
                  >
                    {
                      (selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.is_slave == 0) && 'Locations'
                    }
                    {
                      (selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.is_slave == 1) && 'Local'
                    }
                  </NavLink>
                </NavItem>
                {/* <NavItem onClick={() => this.changeTab('both')}>
                  <NavLink
                    className={activeTab == 'both' ? 'active' : ''}
                  >
                    Both
                  </NavLink>
                </NavItem> */}
              </Nav>
              <TabContent activeTab="1">
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <div className="table_wrapper favorites_table">
                        <div className='table-responsive'>
                          <Table className='table table-striped mb-0 table'>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Created</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                favourites.length > 0 && favourites.map((history, i) => {
                                  return(
                                    <tr>
                                      <td>{i+1}</td>
                                      <td className="clickable-td" onClick={() => this.showFavouriteDetail(history.conversation_uuid)}>{history.title}</td>
                                      <td>{history.created_at}</td>
                                      <td>
                                          {
                                            (selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.id == history.favourite.location_id) &&
                                              <button  onClick={() => this.unMarkFavourite(history.conversation_uuid)} className="delete_btn"><i className="fa fa-fw fa-trash"></i></button>
                                          }
                                      </td>
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>


          </div>
          <div className="modal-footer">
            <Button
              color="primary"
              type="button"
              onClick={() => this.closeModal()}
            >
              Close
            </Button>
          </div>
        </Modal>

        <div
          className={`newDashboardPage 
                ${
                  selectedBusinessLocationObject == null ||
                  (selectedBusinessLocationObject != null &&
                    !selectedBusinessLocationObject.stripe_plan_id)
                    ? "disabled"
                    : ""
                }`}
        >
          <div className="page-content">
            <div className="title_buttons d-flex justify-content-between gap-3 flex-wrap align-items-center">
              <h1>Dashboard</h1>
              <div className="rightButtons d-flex gap-3">
                <Link to="/items/list">
                  <button>Item List</button>
                </Link>
                <Link to="/orders/add">
                  <button>Create Order</button>
                </Link>
                <Link to="/items/add">
                  <button>Add Item</button>
                </Link>
                <Link to="/vendors/add">
                  <button>Add Supplier</button>
                </Link>
              </div>
            </div>
            <div className="wrapperInner">
              <div className="row">
                <div className="col-md-8">
                  <div className="BlockwhiteBgRadius pl-0 pr-0 ">
                    {/* <label className="comingSoon mb-0">Coming Soon</label> */}
                    <div className="title_desc_btns border-bottom pb-4 mb-4 d-flex justify-content-between gap-2">
                      <div className="">
                        <h2>WookAI GPT</h2>
                        <p className="smallDesc mb-0">
                          Ask about costs, suppliers, recipes, or inventory.
                          Try: Analyze this week’s food cost.
                        </p>
                      </div>
                      <div className="groupBtns">
                        <button onClick={() => this.createChat()}>New Chat</button>
                        {/* <button>Mark Favourite</button> */}
                        {
                          (selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.is_slave == 0) && 
                          <UncontrolledDropdown className="favorite_btn">
                            <DropdownToggle
                              caret
                              color="dark"
                            >
                            Mark Favorite
                            </DropdownToggle>
                            <DropdownMenu dark>
                              <DropdownItem onClick={() => this.markFavourite('master')}>
                                Enterprise
                              </DropdownItem>
                              <DropdownItem onClick={() => this.markFavourite('slave')}>
                                Location
                              </DropdownItem>
                              {/* <DropdownItem onClick={() => this.markFavourite('both')}>
                                Both
                              </DropdownItem> */}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        }
                        { (selectedBusinessLocationObject != undefined && selectedBusinessLocationObject.is_slave == 1 )&&
                          <button onClick={() => this.markFavourite('slave')}>Mark Favourite</button>
                        }
                        
                        <button onClick={() => this.openModal()}>Favorites</button>
                      </div>
                    </div>
                    <div className="AIChatBox">
                      <div className="AIChatBoxWrapper" ref={this.chatScrollRef}>
                        {
                          gpt.length > 0 && gpt.map((msg, i) => (
                            <>
                              {msg.sender_type === 'user' && (
                                <div className="mb-2 d-flex justify-content-end align-items-end" key={i}>
                                  <div className="myMessage">
                                  <div className="">
                                    {msg.message}
                                    </div>
                                  </div>

                                  <div className="avatarImg ml-3">
                                    {userObject.image
                                      ?
                                      <img className="rounded-circle header-profile-user" alt="Header Avatar" id="page-header-user-dropdown" tag="button" src={`${BUCKET_URL}/${userObject.image}`} />
                                      :
                                      <img className="rounded-circle header-profile-user" alt="Header Avatar" id="page-header-user-dropdown" tag="button" src={`${ASSETS_PATH}/images/noimagefound.jpg`} />}
                                  </div>
                                </div>
                              )}


                              {msg.sender_type === 'bot' && (
                                <>
                                  <div className="mb-2 d-flex justify-content-start align-items-end">
                                    <div className="avatarImg mr-3">
                                      <img src={WookaiAI} alt="WookaiAI" />
                                    </div>
                                    <div className="aiMessageWrap">
                                    <div className="aiMessage"
                                      dangerouslySetInnerHTML={{ __html: this.formatAIMessage(msg.message) }}
                                    >
                                    </div>
                                    <div className="like_dislike_wrap">
                                      <button onClick={() => navigator.clipboard.writeText(msg.message)} className="" aria-label="Copy" aria-pressed="false" data-testid="copy-turn-action-button" data-state="closed">
                                          <span className="flex items-center justify-center touch:w-10 h-8 w-8">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clipPath="url(#clip0_10358_38623)">
                                              <path d="M12.668 10.667C12.668 9.95696 12.668 9.46296 12.637 9.07896C12.6263 8.86991 12.5883 8.66316 12.524 8.46396L12.469 8.33396C12.3151 8.0328 12.0812 7.77988 11.793 7.60296L11.666 7.53096C11.508 7.45096 11.296 7.39396 10.921 7.36296C10.537 7.33196 10.044 7.33196 9.33296 7.33196H6.49996C5.78896 7.33196 5.29596 7.33196 4.91196 7.36296C4.70291 7.37365 4.49616 7.41164 4.29696 7.47596L4.16696 7.53096C3.8658 7.68484 3.61288 7.91873 3.43596 8.20696L3.36596 8.33396C3.28496 8.49196 3.22796 8.70396 3.19696 9.07896C3.16596 9.46296 3.16496 9.95596 3.16496 10.667V13.5C3.16496 14.211 3.16496 14.704 3.19696 15.088C3.22796 15.464 3.28496 15.675 3.36496 15.833L3.43496 15.959C3.61196 16.247 3.86496 16.481 4.16696 16.635L4.29696 16.691C4.44096 16.743 4.62996 16.78 4.91196 16.803C5.29596 16.834 5.78896 16.835 6.49996 16.835H9.33296C10.043 16.835 10.537 16.835 10.921 16.803C11.297 16.772 11.508 16.715 11.666 16.635L11.793 16.565C12.08 16.388 12.315 16.135 12.469 15.833L12.524 15.703C12.576 15.559 12.614 15.37 12.637 15.088C12.668 14.704 12.668 14.211 12.668 13.5V10.667ZM13.998 12.665C14.453 12.663 14.801 12.66 15.088 12.637C15.464 12.606 15.675 12.549 15.833 12.469L15.959 12.398C16.247 12.221 16.481 11.968 16.635 11.666L16.691 11.536C16.7549 11.3367 16.7926 11.13 16.803 10.921C16.834 10.537 16.835 10.044 16.835 9.33296V6.49996C16.835 5.78896 16.835 5.29596 16.803 4.91196C16.7926 4.70296 16.7549 4.4962 16.691 4.29696L16.635 4.16696C16.4811 3.8658 16.2472 3.61288 15.959 3.43596L15.833 3.36596C15.675 3.28496 15.463 3.22796 15.088 3.19696C14.704 3.16596 14.211 3.16496 13.5 3.16496H10.667C9.95696 3.16496 9.46296 3.16596 9.07896 3.19696C8.79696 3.21996 8.60796 3.25696 8.46396 3.30896L8.33396 3.36496C8.0328 3.51884 7.77988 3.75273 7.60296 4.04096L7.53096 4.16696C7.45096 4.32496 7.39396 4.53696 7.36296 4.91196C7.33996 5.19896 7.33596 5.54696 7.33396 6.00196H9.33296C10.022 6.00196 10.579 6.00196 11.029 6.03796C11.487 6.07596 11.894 6.15496 12.271 6.34696L12.488 6.46896C12.984 6.77296 13.388 7.20896 13.653 7.72896L13.72 7.87196C13.864 8.20896 13.93 8.56996 13.962 8.97096C13.999 9.42096 13.998 9.97796 13.998 10.667V12.665ZM18.165 9.33296C18.165 10.022 18.165 10.579 18.129 11.029C18.096 11.43 18.031 11.791 17.887 12.128L17.82 12.271C17.555 12.791 17.15 13.227 16.655 13.531L16.436 13.653C16.06 13.845 15.654 13.924 15.196 13.962C14.859 13.989 14.462 13.993 13.996 13.995C13.993 14.462 13.989 14.859 13.962 15.196C13.929 15.597 13.864 15.958 13.72 16.294L13.653 16.436C13.388 16.958 12.984 17.394 12.488 17.698L12.271 17.82C11.894 18.012 11.487 18.091 11.029 18.129C10.579 18.166 10.022 18.165 9.33296 18.165H6.49996C5.80996 18.165 5.25396 18.165 4.80396 18.129C4.40396 18.096 4.04196 18.031 3.70596 17.887L3.56296 17.82C3.04347 17.555 2.60714 17.1519 2.30196 16.655L2.17996 16.436C1.98796 16.06 1.90896 15.654 1.87096 15.196C1.83396 14.746 1.83496 14.189 1.83496 13.5V10.667C1.83496 9.97796 1.83496 9.42096 1.87096 8.97096C1.90896 8.51296 1.98796 8.10596 2.17996 7.72896L2.30196 7.51196C2.60596 7.01596 3.04196 6.61196 3.56296 6.34696L3.70596 6.27996C4.04196 6.13596 4.40296 6.06996 4.80396 6.03796C5.14096 6.01096 5.53696 6.00596 6.00396 6.00396C6.00596 5.53696 6.01096 5.14096 6.03796 4.80396C6.07496 4.34596 6.15496 3.93996 6.34696 3.56396L6.46896 3.34396C6.77296 2.84896 7.20896 2.44496 7.72896 2.17996L7.87196 2.11296C8.20896 1.96896 8.56996 1.90296 8.97096 1.87096C9.42096 1.83396 9.97796 1.83496 10.667 1.83496H13.5C14.19 1.83496 14.746 1.83496 15.196 1.87096C15.654 1.90896 16.06 1.98796 16.436 2.17996L16.656 2.30196C17.151 2.60596 17.555 3.04196 17.82 3.56296L17.887 3.70596C18.031 4.04196 18.097 4.40296 18.129 4.80396C18.166 5.25396 18.165 5.81096 18.165 6.49996V9.33296Z" fill="black"/>
                                              </g>
                                              <defs>
                                              <clipPath id="clip0_10358_38623">
                                              <rect width="20" height="20" fill="white"/>
                                              </clipPath>
                                              </defs>
                                            </svg>

                                          </span>
                                      </button>

                                      {
                                          msg.flag === null &&
                                          <button onClick={() => this.reactOnMsg(msg.uuid, msg.flag, true )} className="" aria-label="Good response" aria-pressed="false" data-testid="good-response-turn-action-button" data-state="closed">
                                          <span className="flex items-center justify-center touch:w-10 h-8 w-8">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clipPath="url(#clip0_10363_3605)">
                                              <path d="M12.5189 5.00298L11.7024 8.36696H16.4626C16.7161 8.36696 16.9662 8.42599 17.1929 8.53936C17.4197 8.65274 17.6169 8.81735 17.769 9.02016C17.9211 9.22297 18.0239 9.45842 18.0693 9.70784C18.1146 9.95727 18.1013 10.2138 18.0303 10.4572L16.1278 16.9892C16.0289 17.3284 15.8226 17.6264 15.54 17.8384C15.2573 18.0504 14.9135 18.165 14.5602 18.165H3.53742C3.10432 18.165 2.68896 17.9929 2.38271 17.6867C2.07647 17.3804 1.90442 16.9651 1.90442 16.532V9.99996C1.90442 9.56686 2.07647 9.1515 2.38271 8.84526C2.68896 8.53901 3.10432 8.36696 3.53742 8.36696H5.79096C6.09477 8.3668 6.3925 8.28189 6.6507 8.12178C6.90889 7.96167 7.1173 7.73271 7.25249 7.46065L10.0694 1.83496C10.4545 1.83973 10.8334 1.93145 11.1781 2.10326C11.5227 2.27507 11.824 2.52254 12.0596 2.82717C12.2951 3.13181 12.4588 3.48573 12.5383 3.8625C12.6178 4.23926 12.6112 4.62913 12.5189 5.00298Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                              <path d="M5.98694 8.36719V18.1652" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                              </g>
                                              <defs>
                                              <clipPath id="clip0_10363_3605">
                                              <rect width="20" height="20" fill="white"/>
                                              </clipPath>
                                              </defs>
                                            </svg>
                                            </span>
                                          </button>
                                      }

                                      {
                                          msg.flag === true &&
                                          <button onClick={() => this.reactOnMsg(msg.uuid, msg.flag, true )} className="" aria-label="Good response" aria-pressed="false" data-testid="good-response-turn-action-button" data-state="closed">
                                          <span className="flex items-center justify-center touch:w-10 h-8 w-8">
                                           <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clip-path="url(#clip0_10390_8068)">
                                              <path d="M12.5208 5.00396L11.7043 8.36794H16.4644C16.718 8.36794 16.968 8.42696 17.1947 8.54034C17.4215 8.65371 17.6187 8.81833 17.7708 9.02114C17.923 9.22395 18.0258 9.45939 18.0711 9.70882C18.1165 9.95824 18.1031 10.2148 18.0321 10.4582L16.1297 16.9902C16.0307 17.3294 15.8245 17.6273 15.5418 17.8393C15.2591 18.0513 14.9153 18.1659 14.562 18.1659H3.53925C3.10615 18.1659 2.69079 17.9939 2.38454 17.6876C2.0783 17.3814 1.90625 16.966 1.90625 16.5329V10.0009C1.90625 9.56784 2.0783 9.15248 2.38454 8.84623C2.69079 8.53999 3.10615 8.36794 3.53925 8.36794H5.79279C6.0966 8.36778 6.39433 8.28287 6.65253 8.12276C6.91072 7.96265 7.11913 7.73369 7.25433 7.46162L10.0712 1.83594C10.4563 1.84071 10.8353 1.93242 11.1799 2.10424C11.5245 2.27605 11.8259 2.52352 12.0614 2.82815C12.2969 3.13278 12.4606 3.4867 12.5401 3.86347C12.6197 4.24024 12.613 4.63011 12.5208 5.00396Z" fill="black" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M5.98438 8.36719V18.1652" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                              </g>
                                              <defs>
                                              <clipPath id="clip0_10390_8068">
                                              <rect width="20" height="20" fill="white"/>
                                              </clipPath>
                                              </defs>
                                              </svg>
                                            </span>
                                          </button>
                                      }

                                      {
                                          msg.flag === null && 
                                          <button onClick={() => this.reactOnMsg(msg.uuid, msg.flag, false )} className="" aria-label="Bad response" aria-pressed="false" data-testid="bad-response-turn-action-button" data-state="closed">
                                            <span className="flex items-center justify-center touch:w-10 h-8 w-8">
                                               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clipPath="url(#clip0_10363_3612)">
                                                  <path d="M7.4812 14.997L8.2977 11.633H3.53751C3.28399 11.633 3.03396 11.574 2.80721 11.4606C2.58046 11.3473 2.38322 11.1827 2.23111 10.9798C2.079 10.777 1.9762 10.5416 1.93085 10.2922C1.8855 10.0427 1.89884 9.78617 1.96983 9.5428L3.87227 3.0108C3.97121 2.6716 4.17749 2.37364 4.46015 2.16164C4.74282 1.94964 5.08662 1.83504 5.43995 1.83504H16.4627C16.8958 1.83504 17.3112 2.00709 17.6174 2.31333C17.9237 2.61958 18.0957 3.03494 18.0957 3.46804V10C18.0957 10.4331 17.9237 10.8485 17.6174 11.1547C17.3112 11.461 16.8958 11.633 16.4627 11.633H14.2092C13.9054 11.6332 13.6076 11.7181 13.3494 11.8782C13.0912 12.0383 12.8828 12.2673 12.7476 12.5394L9.9307 18.165C9.54566 18.1603 9.16667 18.0686 8.82206 17.8967C8.47744 17.7249 8.1761 17.4775 7.94056 17.1728C7.70502 16.8682 7.54137 16.5143 7.46182 16.1375C7.38228 15.7607 7.3889 15.3709 7.4812 14.997Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                                  <path d="M14.0132 11.6328V1.83481" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                                  </g>
                                                  <defs>
                                                  <clipPath id="clip0_10363_3612">
                                                  <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 -1 20 20)"/>
                                                  </clipPath>
                                                  </defs>
                                                </svg>
                                            </span>
                                          </button>
                                      }

                                       {
                                          msg.flag === false && 
                                          <button onClick={() => this.reactOnMsg(msg.uuid, msg.flag, false )} className="" aria-label="Bad response" aria-pressed="false" data-testid="bad-response-turn-action-button" data-state="closed">
                                            <span className="flex items-center justify-center touch:w-10 h-8 w-8">
                                               <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_10390_8073)">
                                                  <path d="M7.47925 14.996L8.29575 11.6321H3.53555C3.28204 11.6321 3.03201 11.573 2.80526 11.4597C2.5785 11.3463 2.38126 11.1817 2.22915 10.9789C2.07705 10.7761 1.97425 10.5406 1.9289 10.2912C1.88354 10.0418 1.89689 9.7852 1.96787 9.54182L3.87032 3.00982C3.96925 2.67062 4.17553 2.37266 4.4582 2.16066C4.74087 1.94866 5.08467 1.83406 5.438 1.83406H16.4607C16.8938 1.83406 17.3092 2.00611 17.6155 2.31236C17.9217 2.6186 18.0938 3.03396 18.0938 3.46706V9.99906C18.0938 10.4322 17.9217 10.8475 17.6155 11.1538C17.3092 11.46 16.8938 11.6321 16.4607 11.6321H14.2072C13.9034 11.6322 13.6057 11.7171 13.3475 11.8772C13.0893 12.0373 12.8809 12.2663 12.7457 12.5384L9.92875 18.1641C9.54371 18.1593 9.16472 18.0676 8.8201 17.8958C8.47549 17.724 8.17415 17.4765 7.93861 17.1718C7.70307 16.8672 7.53941 16.5133 7.45987 16.1365C7.38033 15.7598 7.38695 15.3699 7.47925 14.996Z" fill="black" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                  <path d="M14.0156 11.6328V1.83481" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                  </g>
                                                  <defs>
                                                  <clipPath id="clip0_10390_8073">
                                                  <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 -1 20 20)"/>
                                                  </clipPath>
                                                  </defs>
                                              </svg>
                                            </span>
                                          </button>
                                      }
                                    </div>         
                                    </div>
                                  </div>

                                  {/* <div className="mb-2 d-flex justify-content-start align-items-end">
                  <div className="avatarImg mr-3">
                    <img src={WookaiAI} alt="WookaiAI" />
                  </div>
                  
                  <div className="aiMessage p-3">
                    <div className="tableWrapper">
                      <p>Price comparison — last 4 weeks</p>
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Week</th>
                              <th>Last Cost</th>
                              <th>Best Available</th>
                              <th>Supplier</th>
                              <th>Delta</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Wk-1</td>
                              <td>$2.68</td>
                              <td>$2.60</td>
                              <td>Sysco</td>
                              <td>-$0.08</td>
                            </tr>
                            <tr>
                              <td>Wk-2</td>
                              <td>$2.70</td>
                              <td>$2.62</td>
                              <td>US Foods</td>
                              <td>-$0.08</td>
                            </tr>
                            <tr>
                              <td>Wk-3</td>
                              <td>$2.73</td>
                              <td>$2.65</td>
                              <td>Gordon</td>
                              <td>-$0.08</td>
                            </tr>
                            <tr>
                              <td>Wk-4</td>
                              <td>$2.74</td>
                              <td>$2.66</td>
                              <td>Sysco</td>
                              <td>-$0.08</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div> */}
                                </>
                              )}
                            </>
                          ))
                        }

                        {
                            gptLoading  &&
                            <div className="mb-2 d-flex justify-content-start align-items-end">
                              <div className="avatarImg bg_transparent mr-3">
                                  <img src={WookaiAIGif} alt="WookaiAI" />
                              </div>
                              <div className="aiMessage">
                                Thinking...
                              </div>
                          </div>
                        }
                      </div>
                      <div className="messageSendOption">
                        <div className="messageSendWrapper d-flex w-100 position-relative">
                          <div className="position-relative w-100">
                            <textarea
                             onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) { // Shift+Enter for new line
                                  e.preventDefault(); // prevent default new line behavior
                                  this.sendMessage(); // call your sendMessage function
                                }
                              }}
                              onChange={(e) => this.chatInputHandler(e)}
                              placeholder="Ask anything… Try “How much mozzarella have I used for July?”"
                              className="messageType"
                              value={chatText}
                            ></textarea>
                            {/* <button className="fileBtn" type="file">
                              <span className="mobileView">Attach File</span>
                              <img src={attachIcon} alt="attachIcon.png" />
                            </button> */}
                          </div>
                          <div className="" onClick={() => this.sendMessage()}>
                            <button className="submitBtn">
                              <span className="mobileView">Send Message</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="38"
                                height="38"
                                fill="currentColor"
                                className="bi bi-arrow-up-short"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="shortCuts align-items-center" ref={this.historyRef}>
                          <label className="mb-0">History: </label>
                          {
                            conversationHistory.length > 0 && conversationHistory.map((conversation, i) => {
                              return (
                                 <div className="badge">
                                  <span className="badge_value"  onClick={() => this.getMessageHistory(conversation.conversation_uuid)}>
                                  {conversation.title}
                                  </span>
                                  <span className="cross_btn" onClick={() => this.deleteConversation(conversation.conversation_uuid)}>
                                    <img  src={CloseBlack} alt="close_black"/></span>
                                </div>
                              )
                            })
                          }

                          {conversationHistory.length < totalConversations && (
                            <button
                              className="more_history"
                              onClick={() => this.getGptHistory(true)}
                            >
                              More...
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="BlockwhiteBgRadius pl-0 pr-0">
                    {/* <label className="comingSoon mb-0">Coming Soon</label> */}
                    <div className="title_desc_btns align-items-center pb-4 d-flex justify-content-between gap-2">
                      <div className="">
                        <h2 className="mb-0">Key Supplies</h2>
                      </div>
                      <div className="groupBtns">
                        <Link to="items/pendingAdditionalInfo">
                          <button>My Items</button>
                        </Link>
                      </div>
                    </div>
                    <div className="suppliesTable table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="text-nowrap" scope="col">
                              Items
                            </th>
                            {/* <th className="text-nowrap" scope="col">
                              Supplier
                            </th> */}
                            <th className="text-nowrap" scope="col">
                              Average Price
                            </th>
                            <th className="text-nowrap" scope="col">
                              Best Price
                            </th>
                            <th className="text-nowrap" scope="col">
                              Average Savings
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {keySupplies.length > 0 &&
                            keySupplies.map((keySuppliy, i) => {
                              return (
                                <tr key={i}>
                                  <td>{keySuppliy.product_name}</td>
                                  {/* <td>{keySuppliy?.choosed.vendor_name}</td> */}
                                  <td>${keySuppliy?.avgUnchoosed ? keySuppliy.avgUnchoosed.toFixed(2) : ''}</td>
                                  <td>
                                    ${keySuppliy?.choosed}

                                  </td>
                                  <td>
                                    $
                                    {keySuppliy?.avg}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <Link to="orders/add">
                      <button className="primaryBtn ml-3 mt-2">
                        Place Order
                      </button>
                    </Link>
                  </div>
                  <div className="BlockwhiteBgRadius pl-0 pr-0">
                    {/* <label className="comingSoon mb-0">Coming Soon</label> */}
                    <div className="title_desc_btns align-items-center border-bottom pb-4 d-flex justify-content-between gap-2">
                      <div className="d-flex gap-10px align-items-center">
                        <h2 className="mb-0">Price History</h2>
                        <div className="selectBy">
                          <Select
                            styles={customStyles2}
                            value={selectedProduct}
                            onChange={this.productChange}
                            options={productList}
                            // classNamePrefix="select2-selection"
                            placeholder="Search by Item"
                            name="fk_category_id"
                            menuPortalTarget={document.body}
                          />
                        </div>
                      </div>

                      <div className="groupBtns">
                        <select
                          className="form-control"
                          id="exampleFormControlSelect1"
                          onChange={(e) => this.supplierChange(e)}
                        >
                          <option value=''>Show All</option>
                           {vendorList.map(
                                (vendor, vendorKey) => {
                                  return (
                                    <option
                                      key={vendorKey}
                                      value={
                                        vendor.id
                                      }
                                    >
                                      {
                                        vendor.vendor_name
                                      }
                                    </option>
                                  );
                                }
                              )}
                        </select>
                      </div>
                    </div>

                    <div className="d-flex gap-10px justify-content-center radioWrapper">
                      <ul className="d-flex gap-10px">
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="days"
                              checked={days == 10}
                              value={days == 10}
                              onChange={() => this.daysChange(10)}
                            />
                            <span className="radioBg"> 10 days </span>
                          </label>
                        </li>
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="days"
                              checked={days == 20}
                              value={days == 20}
                              onChange={() => this.daysChange(20)}
                            />
                            <span className="radioBg"> 20 days </span>
                          </label>
                        </li>
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="days"
                              checked={days == 30}
                              value={days == 30}
                              onChange={() => this.daysChange(30)}
                            />
                            <span className="radioBg"> 30 days </span>
                          </label>
                        </li>
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="days"
                              checked={days == 60}
                              value={days == 60}
                              onChange={() => this.daysChange(60)}
                            />
                            <span className="radioBg"> 60 days </span>
                          </label>
                        </li>
                        <li>
                          <label>
                            <input
                              type="radio"
                              name="days"
                              checked={days == 90}
                              value={days == 90}
                              onChange={() => this.daysChange(90)}
                            />
                            <span className="radioBg"> 90 days </span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div className="graphWrapper">
                      {/* <PriceHistoryGraph /> */}
                      <Line options={options} data={graphData} />
                      {/* <img className='w-100 h-auto px-3' src={newGraph} alt='newGraph' /> */}
                    </div>
                  </div>
                  <div className="row align-items-strecth">
                    <div className="col-lg-6 d-flex">
                      {/* <div className="BlockwhiteBgRadius w-100 comingSoonWrapper"> */}
                      <div className="BlockwhiteBgRadius w-100">
                        {/* <label className="comingSoon mb-0">Coming Soon</label> */}
                        <div className="title_desc_btns pl-0 pr-0 align-items-center pb-3 d-flex justify-content-between gap-2">
                          <div className="">
                            <h2 className="mb-0">Menu Profitability</h2>
                          </div>
                          <div className="groupBtns">
                            <select
                              value={highOrLow}
                              className="form-control"
                              id="exampleFormControlSelect1"
                              onChange={(e) => this.profitabilityChange(e)}
                            >
                              <option value="low">Top 5 Highest</option>
                              <option value="high">Top 5 Lowest</option>
                            </select>
                          </div>
                        </div>
                        <div className="profitabilityWrapper bg-gray">
                          <div className="d-flex progress_name">
                            <label className="itemName mb-0"><strong>Name</strong></label>
                            <label className="itemName mb-0"><strong>Size</strong></label>
                            <label className="itemName mb-0"><strong>Profit %</strong></label>
                          </div>
                        </div>
                        <div className="profitabilityWrapper">
                          {
                            highOrLow == 'high' && top5Highest.map((value, index) => {
                                return(
                                    <div key={index} className="d-flex progress_name align-items-start">
                                    <label className="itemName mb-0">
                                      {value.ideal_product_cost_name_clone}
                                    </label>
                                    <label className="itemName mb-0">
                                        {value.item_size}
                                    </label>
                                    <div className="progressbar_Wrapper w-100 d-flex align-items-center">
                                      {/* <div className="progress">
                                        <div
                                          className="progress-bar"
                                          role="progressbar"
                                          style={{ width: "32%" }}
                                          aria-valuenow="32"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        >
                                          32%
                                        </div>
                                      </div> */}
                                      {/* <span>32%</span> */}
                                      <span>{value.actual_cost_goods}</span>
                                    </div>
                                  </div>
                                )
                            })
                          }

                          {
                            highOrLow == 'low' && top5Lowest.map((value, index) => {
                                return(
                                    <div key={index} className="d-flex progress_name align-items-center">
                                    <label className="itemName mb-0">
                                      {value.ideal_product_cost_name_clone}
                                    </label>
                                    <label className="itemName mb-0">
                                        {value.item_size}
                                    </label>
                                    <div className="progressbar_Wrapper w-100 d-flex align-items-center">
                                      {/* <div className="progress">
                                        <div
                                          className="progress-bar"
                                          role="progressbar"
                                          style={{ width: "32%" }}
                                          aria-valuenow="32"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        >
                                          32%
                                        </div>
                                      </div> */}
                                      {/* <span>32%</span> */}
                                      <span>{value.actual_cost_goods}</span>
                                    </div>
                                  </div>
                                )
                            })
                          }

                          <Link to="/reports/variance">
                            <button className="primaryBtn">
                              Open MenuMatic
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 d-flex">
                      <div className="w-100 BlockwhiteBgRadius comingSoonWrapper position-relative">
                        <label className="comingSoon mb-0">Coming Soon</label>
                        <h5>Prep and Inventory Health</h5>
                        <div className="twoBtns">
                          <button>Prep Today</button>
                          <button>Low Stock</button>
                        </div>
                        <div className="prepStatus mt-4">
                          <div className="statusSingle align-items-center p-2 border d-flex justify-content-between">
                            Grill Prep — 10:00 AM
                            <label className="onTrack mb-0">On Track</label>
                          </div>
                          <div className="statusSingle align-items-center p-2 border d-flex justify-content-between">
                            Sauce Batch — 2:00 PM
                            <label className="dueSoon mb-0">Due Soon</label>
                          </div>
                          <div className="statusSingle align-items-center p-2 border d-flex justify-content-between">
                            Inventory Count — Today
                            <label className="Overdue mb-0">Overdue</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="rightSideBlocks">
                    <div className="BlockwhiteBgRadius">
                      <h2>Quick Actions</h2>
                      <div className="blocksWrapper">
                        <Link
                          to="/savedOrders/list"
                          className="exportBtn w-100"
                        >
                          <button className="exportBtn w-100">
                            <img src={uploadIcon} alt="uploadIcon" />
                            <h4>Exports from App</h4>
                          </button>
                        </Link>
                        <Link to="/orders/list" className="downloadBtn w-100">
                          <button className="downloadBtn w-100">
                            <img src={downloadIcon} alt="downloadIcon" />
                            <h4>Receive</h4>
                          </button>
                        </Link>
                        <Link to="/procedures/add" className="recipeBtn w-100">
                          <button className="recipeBtn  w-100">
                            <img src={recipeIcon} alt="recipeIcon" />
                            <h4>Build Recipe</h4>
                          </button>
                        </Link>
                        <Link
                          to="/ideal-product-cost/add"
                          className="menuBtn w-100"
                        >
                          <button className="menuBtn w-100">
                            <img src={menuIcon} alt="menuIcon" />
                            <h4>Build a Menu Item</h4>
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="BlockwhiteBgRadius">
                      <h2>Help and Learning</h2>
                      <div className="blocksWrapper threeBlocks">
                        <div
                          className="heroBlock block"
                          onClick={() =>
                            window.open(
                              "https://wookai.com/setup-options/wookai-members-only",
                              "_blank"
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <img src={youTubeIcon} alt="youTubeIcon.png" />
                          <h3>Hero Help Video</h3>
                          <p>Watch a quick guide to get started</p>
                        </div>
                        <div className="scheduleBlock block">
                          <img
                            src={videoCalendarIcon}
                            alt="videoCalendarIcon.png"
                          />
                          <h3>Schedule Zoom Meeting</h3>
                          <p>support with our team on Zoom.</p>
                          <button
                            onClick={() =>
                              window.open(
                                "https://meetings.hubspot.com/david3724?uuid=a9a17776-dfd3-4a49-a15c-a21f40c526e0",
                                "_blank"
                              )
                            }
                            className="sessionBtn"
                          >
                            Book a Session
                          </button>
                        </div>
                        <div className="newBlock block">
                          <img src={starsIcon} alt="starsIcon" />
                          <h3>What's New</h3>
                          <p>New dashboard features released!</p>
                          <Link to="/">
                            Learn More
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-arrow-right-short"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="BlockwhiteBgRadius noteAble pl-0 pr-0 overlayWrap comingSoonWrapper">
                      <h2>
                        Noteable Items <img src={pinIcon} alt="pinIcon.svg" />
                      </h2>
                      <div className="blocksWrapper noteWrapper">
                        <div className="itemsCount d-flex flex-wrap align-items-center">
                          <img src={menuItemIcon} alt="menuItemIcon.svg" />
                          <label>
                            Menu Item Over Target
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                />
                              </svg>
                            </span>
                            {menuItemOverTarget}
                          </label>
                        </div>
                        {/* <div className='itemsCount d-flex flex-wrap align-items-center'>
                                                <img src={graphIcon} alt='graphIcon.svg' />
                                                <label>Price Drift {'>'} 5%
                                                    <span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg>
                                                    </span>8 SWs
                                                </label>
                                            </div> */}
                        <div className="itemsCount d-flex flex-wrap align-items-center">
                          <img src={fileIcon} alt="fileIcon.svg" />
                          <label>
                            Contracts Expiring
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                />
                              </svg>
                            </span>
                            {contractsExpiring}
                          </label>
                        </div>
                        <div className="itemsCount d-flex flex-wrap align-items-center">
                          <img src={dollorIcon} alt="dollorIcon.svg" />
                          <label>
                            Rebates Expiring
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                />
                              </svg>
                            </span>
                            {rebatesExpiring}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default withRouter(Dashboard);
